interface RequestException {
    requestUrl?: unknown;
    statusCode?: unknown;
    errorCode?: unknown;
}

export const getErrorRequestFingerprint = (exception: unknown): string[] => {
    if (exception == null) {
        return [];
    }

    const fingerprint: string[] = [];

    const requestException = exception as RequestException;

    if (typeof requestException.requestUrl === 'string') {
        try {
            const url = new URL(requestException.requestUrl);

            // Use only pathname because we use different environments on different domains but we still want those errors to be grouped together.
            fingerprint.push(url.pathname);
            // eslint-disable-next-line @mews/no-empty-catch
        } catch {
            /* empty */
        }
    }

    if (typeof requestException.statusCode === 'number') {
        fingerprint.push(requestException.statusCode.toString(10));
    }

    if (typeof requestException.errorCode === 'string') {
        fingerprint.push(requestException.errorCode);
    }

    return fingerprint;
};
